<template>
    <div class="modal-container">
        <div class="modal-header md-accent">
            <p>
                No license available for new user
            </p>
        </div>
        <div class="modal-body">
            <p>
                {{ warningMessage }}
            </p>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">Cancel</md-button>
            <!-- temporarily commented until further logic is added (still in another big PR-4080) -->
            <!-- <md-button class="dialog-button md-primary reload-icon" @click.stop="redirectToBillingProfile">
                BUY MORE LICENSES
            </md-button> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'LicenseWarningModal',
    props: {
        licensedUser: { type: Number, default: () => 1 }
    },
    computed: {
        warningMessage() {
            if (this.licensedUser && this.licensedUser > 0) {
                return `You have reached the ${this.licensedUser} user limit. You have to purchase more licenses.`;
            }

            return 'No license found.';
        }
    },
    methods: {
        redirectToBillingProfile() {
            this.$router.push({ name: 'Billing Profile' });
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-header {
    background-color: #f44336;
    color: white !important;
    font-weight: bold;
}
</style>
